import { createSlice } from "@reduxjs/toolkit";

let initialState = {
    answers: null,
    openQuestionDialog: false,
};

export const guestlist = createSlice({
  name: "guestlist",
  initialState,
  reducers: {
    setAnswers: (state, action) => {
      state.answers = action.payload;
    },
    setOpenQuestionDialog: (state, action) => {
      state.openQuestionDialog = action.payload;
    },
  },
});

export const {
    setAnswers,
    setOpenQuestionDialog
} = guestlist.actions; // Export the setSelectedWave action

export default guestlist.reducer;
